var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "flex flex-col gap-1 overflow-hidden pl-2 pt-1",
      class: [
        {
          "soli-grey": !_vm.arg.timeText,
          "white--text": _vm.arg.timeText,
        },
      ],
    },
    [
      _vm.arg.timeText
        ? _c(
            "b",
            {
              staticClass: "flex justify-between",
              class: _vm.arg.isMirror ? "soli-grey" : null,
            },
            [
              _vm._v(_vm._s(_vm.arg.timeText) + "\n        "),
              _vm.arg.event.extendedProps.students
                ? _c(
                    "div",
                    [
                      Object.values(_vm.arg.event.extendedProps.students).every(
                        (e) => e.attendance.status
                      )
                        ? _c(
                            "v-icon",
                            {
                              staticClass: "float-right pr-1 white--text",
                              attrs: { dense: "", right: "" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.arg.event.extendedProps.cancelled
                                    ? "do_not_disturb"
                                    : "check_circle"
                                )
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isPlaceholder(_vm.arg)
        ? _c("small", [
            _vm._v(
              "\n        " +
                _vm._s(
                  `Starts ${_vm.globalMomentDate(
                    _vm.arg.event.extendedProps.displayStart
                  )}`
                ) +
                "\n    "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.arg.event.title
        ? _c("div", { staticClass: "lesson-event-title flex flex-col" }, [
            _c(
              "small",
              {
                staticClass: "whitespace-nowrap",
                class: {
                  "subtitle-2 font-bold":
                    _vm.arg.event.extendedProps.group_event,
                  "leading-4": !_vm.arg.event.extendedProps.group_event,
                },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      `${_vm.arg.event.extendedProps.online ? "Online " : ""}${
                        _vm.arg.event.title
                      }`
                    ) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            !_vm.arg.event.extendedProps.group_event
              ? _c("div", { staticClass: "subtitle-2 font-bold" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.arg.event.extendedProps.student
                          ? _vm.arg.event.extendedProps.student.name
                          : null
                      ) +
                      "\n        "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.hideLessons
              ? _c(
                  "small",
                  { staticClass: "flex justify-start align-center" },
                  [_vm._v(_vm._s(_vm.getTeacher(_vm.arg.event)) + "\n        ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.arg.event.extendedProps.group_event &&
            _vm.arg.event.extendedProps.students
              ? _c(
                  "div",
                  { staticClass: "flex flex-col" },
                  [
                    _c("v-divider", {
                      staticClass: "my-2 mr-2",
                      attrs: { color: "white" },
                    }),
                    _vm._v(" "),
                    _c("small", [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            `${
                              _vm.arg.event.extendedProps.students.filter(
                                (e) => e.enrolled
                              ).length
                            } / ${
                              _vm.arg.event.extendedProps.capacity
                                ? _vm.arg.event.extendedProps.capacity
                                : ""
                            } Enrolled`
                          ) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("small", [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            `${
                              _vm.arg.event.extendedProps.students.filter(
                                (e) => e.attending
                              ).length
                            } Attending`
                          ) +
                          "\n            "
                      ),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.arg.event.extendedProps.series
              ? _c("small", { staticClass: "flex" }, [
                  _vm._v(
                    _vm._s(
                      `${
                        _vm.arg.event.extendedProps.cancelled
                          ? "Cancelled"
                          : _vm.arg.event.extendedProps.series.n
                      } of ${_vm.arg.event.extendedProps.series.series}`
                    )
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }